import { render } from "./BlocNewsletter.vue?vue&type=template&id=9c04db36&scoped=true"
const script = {}

import "./BlocNewsletter.vue?vue&type=style&index=0&id=9c04db36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c04db36"]])

export default __exports__